import {
  phoneWithCharactersValidator,
  requiredValidator,
} from '@utils/validators';
import { validateRequired } from '@common/functions/validators';
import phoneValidator from '@utils/validators/phoneValidator';

export const helpdeskAIValidation = values => {
  const rules = {
    name: requiredValidator(values.agentName),
    agentName: requiredValidator(values.agentName),
    companyName: requiredValidator(values.companyName),
    incomingPhoneNumberId: validateRequired(values.incomingPhoneNumberId),
    crmTicketDefaultId: requiredValidator(values.crmTicketDefaultId),
    language: requiredValidator(values.language),
    introMessage: requiredValidator(values.introMessage),
    outroMessage: requiredValidator(values.outroMessage),
    typeId: requiredValidator(values.typeId),
    fallbackPhoneNumber:
      phoneWithCharactersValidator(values.fallbackPhoneNumber, 1) ||
      phoneValidator(
        values.fallbackPhoneNumber,
        values.fallbackPhoneNumberCountryCode,
      ),
    fallbackPhoneNumberCountryCode: requiredValidator(
      values.fallbackPhoneNumberCountryCode,
    ),
  };

  if (values.phoneNumberToggle === 'true') {
    rules.callTransferPhoneNumberCountryCode = requiredValidator(
      values.callTransferPhoneNumberCountryCode,
    );
    rules.callTransferPhoneNumber =
      phoneWithCharactersValidator(values.callTransferPhoneNumber, 1) ||
      phoneValidator(
        values.callTransferPhoneNumber,
        values.callTransferPhoneNumberCountryCode,
      );
  }

  return rules;
};

export default {};
